import { render } from "./App.vue?vue&type=template&id=539a3ea4"
const script = {}
script.render = render

export default script